import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { FinalProductService } from '../proxy/general/controllers/final-product.service';
import { SapMaterialService } from '@controlling/proxy/controlling/controllers';
import { Species } from '@general/species/species';
import { SpeciesGroupPlantType } from '@general/species-group-plant-type/species-group-plant-type';
import { SpeciesGroupChipCubicMeterCoefficient } from '@general/species-group-chip-cubic-meter-coefficient/species-group-chip-cubic-meter-coefficient';

FieldBuilder.setNamespace('General');

export const SPECIESGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SpeciesGroup.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SpeciesGroup.Code')
    .required()
    .maxLength(4)
    .build(),
  FieldBuilder
    .number('density', 'Entity.SpeciesGroup.Density')
    .required()
    .decimal(3,10)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('sapWoodMaterialId', 'Entity.SpeciesGroup.SapWoodMaterial', SapMaterialService)
    .display('description')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('finalProductId', 'Entity.FinalProduct', FinalProductService)
    .displayFromNested('finalProduct.name')
    .sortBy('finalProduct.name')
    .build(),
  FieldBuilder
    .number('standardHumidityPercentage', 'Entity.SpeciesGroup.StandardHumidityPercentage')
    .required()
    .decimal(3,10)
    .build(),
];

export const SPECIESGROUP_CONFIG = {
  entityName: 'SpeciesGroup',
  localizationKey: 'General::Entity.SpeciesGroup',
  fields: SPECIESGROUP_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.SpeciesGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
  children: [
        {
          entityName: 'Species',
          foreignKeyField: 'speciesGroupId',
          localizationKey: 'General::Entity.Species',
          component: Species,
        },
        {
          entityName: 'SpeciesGroupPlantType',
          foreignKeyField: 'specieGroupId',
          localizationKey: 'General::Entity.SpeciesGroupPlantType',
          component: SpeciesGroupPlantType,
        },
        {
          entityName: 'SpeciesGroupChipCubicMeterCoefficient',
          foreignKeyField: 'speciesGroupId',
          localizationKey: 'General::Entity.SpeciesGroupChipCubicMeterCoefficient',
          component: SpeciesGroupChipCubicMeterCoefficient,
        }
      ]
};
